import styles from './TransportTypeSelector.module.scss'
import ratioTravelObject from '@/entities/ratioTravel/interface'
import CustomSelect from '@/components/elements/inputs/CustomSelect'
import { useTranslation } from 'next-i18next'
import { useContext, useEffect, useState } from 'react'
import { useAppDispatch, useAppSelector } from '@/app/hooks'
import { getStateBooking, selectBookings, setPricingTravelId } from '@/features/booking'
import { TravelIdContext } from '@/app/context'
import { CustomSelectOption } from '@/components/elements/inputs/CustomSelect/CustomSelect'

interface Props {
  pricingTravels: ratioTravelObject[]
  colorTheme?: 'light' | 'dark'
}

const TransportTypeSelector = ({ pricingTravels, colorTheme = 'light' }: Props) => {
  const { t } = useTranslation('common')

  const travelId = useContext(TravelIdContext)
  const dispatch = useAppDispatch()
  const bookings = useAppSelector(selectBookings)
  const booking = getStateBooking(bookings, travelId)

  const [activePricingTravel, setActivePricingTravel] = useState<ratioTravelObject | undefined>(
    pricingTravels.length === 1 ? pricingTravels[0] : undefined
  )
  useEffect(() => {
    if (activePricingTravel) {
      dispatch(setPricingTravelId({ travelId: travelId, pricingTravelId: activePricingTravel.id as number }))
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activePricingTravel])

  const onChange = (pricingTravel: CustomSelectOption<ratioTravelObject>) => {
    setActivePricingTravel(pricingTravel)
  }

  return (
    <>
      {booking && pricingTravels.length > 1 && (
        <CustomSelect
          variant={colorTheme === 'light' ? 'default' : 'whiteOutline'}
          placeholder={t('booking.transportType')}
          options={pricingTravels}
          selected={booking.pricingTravel as CustomSelectOption<ratioTravelObject>}
          onChange={onChange}
          renderOption={(pricingTravel: CustomSelectOption<ratioTravelObject>) => {
            return (
              <div className={styles.option}>
                <div className={styles.date}>{pricingTravel.transportTypeLabel}</div>
              </div>
            )
          }}
          renderInputValue={(pricingTravel: CustomSelectOption<ratioTravelObject>) => {
            return <>{pricingTravel.transportTypeLabel}</>
          }}
        />
      )}
    </>
  )
}

export default TransportTypeSelector
